import {
  Component,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
  signal,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-home-settings-section",
  templateUrl: "./home-settings-section.component.html",
  styleUrls: ["./home-settings-section.component.scss"],
  standalone: false
})
export class HomeSettingsSectionComponent implements OnInit {
  @Input() menuCollapsed;
  @Input() settings;
  @Input() printProduct;
  @Input() isLoading!: boolean;

  @Output() menuCollapseChanged = new EventEmitter();
  @Output() settingSelectedEvent = new EventEmitter();
  @Output() closeSettingsEvent = new EventEmitter();

  isMobile = input<boolean>(false);
  settingsSectionHeight = input(0);

  settingsConfigTitleHeight = signal(0);
  settingsSelectorButtonsHeight = signal(0);

  settingSelector = "general";
  zoomLevel: number = 100;
  paddingScrolableMobile = "0px";

  constructor() { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.printProduct && changes.printProduct.currentValue) {
      this.settingSelector = "general";
    }
  }

  setSettingSelector(value) {
    this.settingSelector = value;
  }

  changeMenuCollapsed() {
    this.menuCollapseChanged.emit();
  }

  settingSelectedOption(event) {
    this.settingSelectedEvent.emit(event);
  }

  protected readonly print = print;

  closeSettings() {
    this.closeSettingsEvent.emit();
  }
}
